import React, { Component } from 'react';
import en from './languages/en.json';
import zh from './languages/zh.json';

const ConfigContext = React.createContext({ language: en });
export { ConfigContext, en, zh }
